import WastePercentReport from "../components/WastePercentReport";

export default function WastePercentReportPage() {
  return <WastePercentReport />;
}
